/**
 * Sophia Platform (Cloudflare Edge-Native Edition)
 *
 * @file        Application Entrypoint for User Workspace SPA (Task 10.1.1)
 * @author      Le Viet Quang <quangle@fourelementscorp.com>
 * @copyright   (c) 2026 Le Viet Quang / Four Elements Corp
 * @license     MIT
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from './context/ThemeProvider';
import { App } from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
});

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </QueryClientProvider>
    </React.StrictMode>,
  );
}
